<template>
  <div>
    <top-header :type="6" placeholder="看房记录" fontSize="0.32rem"/>
    <div class="record_list">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="no_data" v-if="!list.length">
            <img src="@/assets/img/nodata.png" alt="">
          </div>
          <div class="row m_flex_box flex_vc flex_jz" v-for="(item, index) in list" :key="index">
            <div class="left m_flex_box flex_vc">
              <img v-lazy="imgPath + 'sClf/' + item.brokerImg + '.jpg'" alt="">
              <div>
                <h5>{{item.brokerName ? item.brokerName : '-'}}</h5>
                <p>{{item.seeDate | formatTime('yyyy-MM-dd')}}带看过本房</p>
              </div>
            </div>
            <div class="right m_flex_box">
              <a @click.stop="callTo(item.brokerPhone, 1, item.id)">
                <img src="@/assets/img/r_tel.png" alt="">
              </a>
              <img src="@/assets/img/r_chat.png" alt="">
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import topHeader from "@/components/header";
export default {
  data() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      list: [],
      houseListedId: this.$route.query.houseListedId,
      mainId: this.$route.query.mainId,
      currPageNo: 1,
      timer: null
    };
  },
  components: {
    topHeader
  },
  filters: {
    formatTime: function (dates, fmt) {
      var date = new Date(dates);
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      var o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      };
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          var str = o[k] + '';
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
        }
      }
      return fmt;
    }
  },
  mounted() {

  },
  methods: {
    callTo(phone, lx, infoId) {
      if(!phone) {
        this.$dialog.alert({
          title: '提示',
          message: '暂无可拨打电话'
        });
        return;
      }
      this.$new.post('telTj/addTeltj.do', qs.stringify({
        phone,
        lx,
        infoId
      })).then(res => {
        window.location.href = `tel:${phone}`
      })
    },
    onRefresh() {
      this.loading = false;
      this.finished = false;
      this.$set(this.formData, 'currPageNo', 1)
      this.$set(this, 'list', [])
      this.onLoad(1);
    },
    onLoad(type) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50)
        this.$http({
          url: 'cms/brokerSeeRecord/permit/getBrokerSeeRecord.do',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            pageSize: 10,
            mainId: this.mainId,
            listId: this.houseListedId,
            currPageNo: this.currPageNo,
          }
        }).then(res => {
          if (type) {
            this.isLoading = false;
          }
          if (res.success) {
            this.list = this.list.concat(res.obj)
            this.loading = false;
            this.$set(this, 'currPageNo', this.currPageNo + 1);
          } else {
            this.finished = true;
          }
        })
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pad_top{
  padding-top: 0.9rem;
}
.record_list{
  width: 7.04rem;
  margin: 0 auto;
  .row{
    padding: 0.2rem 0;
    &:last-child{
      padding-bottom: 0;
    }
    .left{
      img{
        width: 0.78rem;
        height: 0.78rem;
        border-radius: 50%;
        margin-right: 0.16rem;
      }
      h5{
        font-size: 0.28rem;
      }
      p{
        font-size: 0.22rem;
        color: #A0A0A0;
      }
    }
    .right{
      img{
        width: 0.62rem;
        height: 0.62rem;
        margin-left: 0.52rem;
      }
      a{
        img{
          margin-left: 0;
        }
      }
    }
  }
}
</style>